/* eslint-disable @typescript-eslint/no-explicit-any */
// Angular
import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Ionic
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonTitle,
  IonToolbar,
  IonIcon,
  ModalController,
  AlertController,
  NavParams
} from '@ionic/angular/standalone';

// Capacitor
import { Capacitor } from '@capacitor/core';

// Third party library
import { takeUntil, of, Observable, Subscription, filter } from 'rxjs';
import * as _ from 'lodash';
import { NativeSettings, AndroidSettings } from 'capacitor-native-settings';

// Local library
import { GeoLocationService, UnsubscribeObservableService } from '@amwager/util';
import { ITicketSlim, IParentTickets, WagerFacade } from '@amwager/wager/data-access';
import { IGeoLocationModel, IGetEventsDetailsResponse, STATUS_ACTIVE } from '@amwager/util-ts';
import { FundingComponent } from '@amwager/funding/feature-ion';
import { AccountFacade } from '@amwager/account/data-access';
import { CommonFacade } from '@amwager/data-access';


@Component({
  selector: 'feature-ion-amwager3-betslip',
  templateUrl: './betslip.component.html',
  styleUrls: ['./betslip.component.scss'],
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonContent,
    IonItem,
    IonInput,
    IonIcon,
    FormsModule,
    CommonModule
  ],
  standalone: true
})
export class BetSlipModalComponent extends UnsubscribeObservableService implements OnInit {

  name: string | undefined;
  bets$!: Observable<ITicketSlim>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // parentTickets$!: Observable<any>;

  geoLocation!: IGeoLocationModel;
  balanceAmount!: number;
  receivedDataTypeBet!: any;

  savedBets$!: Observable<any>;
  activeBets$!: Observable<any>;
  closedBets$!: Observable<any>;

  showSavedBets!: boolean;
  showActiveBets!: boolean;
  showClosedBets!: boolean;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  events$!: any;
  // parentTickets: ITicketSlim[] = [];
  savedTickets: ITicketSlim[] = [];
  activeTickets: ITicketSlim[] = [];
  totalAmount!: number;
  isProcessing: boolean = false;
  isExceedsSubmitSaveBetErr: boolean = false;
  isGenericSubmitSaveBetErr: boolean = false;

  allEventTrackRace$!: any;

  runId?: string;

  private subsGetCompleteRegistrationResponse!: Subscription;
  private subsGetjurisdictionsResponse!: Subscription;

  private isSubmitSavedBetSuccessSubs!: Subscription;
  private isRemoveSavedBetSuccessSubs!: Subscription;
  private isCancelBetSuccessSubs!: Subscription;
  private getSelectedEventTrackSubs!: Subscription;

  constructor(
    private geoLocationService: GeoLocationService,
    private modalCtrl: ModalController,
    private readonly alertCtrl: AlertController,
    private navParams: NavParams,
    private readonly accountFacade: AccountFacade,
    private readonly wagerFacade: WagerFacade,
    private readonly cdRef: ChangeDetectorRef,
    private readonly ngZone: NgZone,
    private readonly commonFacade: CommonFacade,
  ) {

    super();
  }

  ngOnInit(): void {

    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('BetSlipModalComponent:ngOnInit', false);
    }
    // update branch 1

    // {
    //   // ticketsId: '',
    //   // parentTicketId: '',
    //   // startTime: new Date,
    //   // endTime: new Date,
    //   runId: res?.ToteResponse.RunId,
    //   // eventId: '',
    //   // raceId: 0,
    //   ticketStatus: ticketStatus,
    //   offset: 0,
    //   next: 500
    // }

    this.receivedDataTypeBet = this.navParams.get('typeBet');

    // console.log(this.receivedDataTypeBet);

    const payload: any = {
      runId: '',
      offset: 0,
      next: 500
    }

    this.showSavedBets = false;
    this.showActiveBets = true;
    this.showClosedBets = false;

    // default active tabs
    // let ticketStatus = 3;

    if (this.receivedDataTypeBet === 'save-bet') {
      // ticketStatus = 1;
      payload.ticketStatus = 1;
      this.showSavedBets = true;
      this.showActiveBets = false;
    }

    this.accountFacade.getBalance$()
      .subscribe((res) => {
        if (res !== undefined) {
          this.balanceAmount = res;
        }
        this.cdRef.markForCheck();
      });

    // for event name
    this.wagerFacade.getSelectAllEventTrackRace$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((res) => {
      this.events$ = res;
    });

    this.getSelectedEventTrackSubs = this.wagerFacade.getSelectedEventTrack$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((res) => {
      // console.log('BetSlipModalComponent', res);
      this.runId = res?.ToteResponse.RunId;
      payload.runId = res?.ToteResponse.RunId;
      // console.log(payload);
      // this.wagerFacade.getBetsAPI(payload, 'BetSlipModalComponent: ngOnInit');

      if (this.getSelectedEventTrackSubs) this.getSelectedEventTrackSubs.unsubscribe();
    });

    // const bet = {
    //   runId: '5867',
    //   ticketStatus: 3,
    //   next: 500
    // }

    // this.wagerFacade.getBetsAPI(bet);
    this.wagerFacade.getBets$()
    .pipe(
      takeUntil(this.toUnsubscribe$),
    )
    .subscribe((response) => {
      // show only active ticket
      // response = _.filter(response, ['TicketStatus', STATUS_ACTIVE]);



      // console.log('RESPONSE:', response);
      if (response !== undefined) {
        // this.parentTickets$ = of(response);
        // const tempResponse = _.filter(response, ['TicketStatus', STATUS_ACTIVE]);
        // this.parentTickets$ = of(tempResponse);

        // this.parentTickets$ = of(_.groupBy(response, 'TicketStatus'));
        // console.log(this.parentTickets$);

        // const groupedTickets = _.groupBy(response, 'ticketStatus');

        // console.log(groupedTickets);

        // this.saveBets$ = of(groupedTickets['1']) || [];
        // this.activeBets$ = of(groupedTickets['3']) || [];
        // this.closedBets$ = of(groupedTickets['6']) || [];

        // console.log(this.saveBets$);

        this.savedBets$ = of(
          response?.saved?.filter((ticket: { TicketStatus: number; }) => ticket.TicketStatus === 1)
        );
        this.activeBets$ = of(
          response?.active?.filter((ticket: { TicketStatus: number; }) => ticket.TicketStatus === 3)
        );
        this.closedBets$ = of(
          response?.close?.filter((ticket: { TicketStatus: number; }) => ticket.TicketStatus === 6)
        );

        this.savedTickets = response?.saved;
        this.activeTickets = response?.active;
        // this.getTotalAmount();
      }

      this.cdRef.markForCheck();
    });

    this.wagerFacade.getTicketGeoLocation$().subscribe((response?: IGeoLocationModel) => {
      if (response === undefined) return;
      // console.log("runner:location:", response)
      this.geoLocation = response;
    });

    this.wagerFacade.getSelectAllEventTrackRace$()
      .subscribe((allEventTrackRace: IGetEventsDetailsResponse[]) => {

      this.allEventTrackRace$ = allEventTrackRace;
      this.cdRef.markForCheck(); // re-render for template
    });

  }

  submitSavedBet(ticket: ITicketSlim): void {

    if (this.isExceedsSubmitSaveBetErr)
      this.isExceedsSubmitSaveBetErr = false;

    if (this.isGenericSubmitSaveBetErr)
      this.isGenericSubmitSaveBetErr = false;

    const currentEvent = _.find(this.allEventTrackRace$, (event) =>
      _.get(event, 'ToteResponse.EventDetail.EventId') === ticket.EventId);

    const currentRace = _.find(currentEvent.ToteResponse.EventDetail.Races, (race) =>
      _.get(race, 'RaceId') === ticket.RaceId);

    if (
      currentEvent.ToteResponse.EventDetail.EventStatus !== "Open" ||
      currentRace.RaceStatus !== 0
    ) {
      this.showAlertInfo('Info', 'Race is closed, no wagering permitted.', 'Close', 0);
      return;
    }

    this.wagerFacade.submitSavedBetAPI(ticket);
    this.isSubmitSavedBetSuccessSubs = this.wagerFacade.isSubmitSavedBetSuccess$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((callback) => {
      // console.log(callback);
      if (callback.response !== undefined) {

        if (callback.response.length > 0) {
          this.isExceedsSubmitSaveBetErr = _.some(
            callback.response[0]?.WageringResponses,
            {'Error': 'Exceeds loss limit.'}
          );

          if (this.isExceedsSubmitSaveBetErr) {
            this.showAlertError('Exceeds loss limit.', '');
          }

          this.isGenericSubmitSaveBetErr = _.some(callback.response[0]?.WageringResponses, (item) =>
            item?.Error?.includes('Please contact your administrator for more information.')
          );

          if (this.isGenericSubmitSaveBetErr) {
            this.showAlertError('Invalid ticket or wager. Please adjust selections.', '');
          }
        }
      }

      if (callback?.isSuccess) {
    //     this.wagerFacade.getBetsAPI({
    //       runId: this.runId,
    //       ticketStatus: 3,
    //       offset: 0,
    //       next: 500
    //     }, 'BetSlipModalComponent: submitSavedBet');

        if (this.isSubmitSavedBetSuccessSubs) this.isSubmitSavedBetSuccessSubs.unsubscribe();

        this.showSavedBets = false;
        this.showActiveBets = true;
      }
    });
  }

  removeSavedBet(ticket: ITicketSlim): void {
    // console.log(ticket);
    // return;
    this.wagerFacade.removeSavedBetAPI(ticket);
    this.isRemoveSavedBetSuccessSubs = this.wagerFacade.isRemoveSavedBetSuccess$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((callback) => {

      if (callback?.isSuccess) {
    //     this.wagerFacade.getBetsAPI({
    //       runId: this.runId,
    //       ticketStatus: 1,
    //       offset: 0,
    //       next: 500
    //     }, 'BetSlipModalComponent: removeSavedBet');

        if (this.isRemoveSavedBetSuccessSubs) this.isRemoveSavedBetSuccessSubs.unsubscribe();
      }
    });
  }

  cancelBet(ticket: ITicketSlim): void {

    // if (ticket.IsCancelled) return;

    if (this.isProcessing) return;

    this.isProcessing = true;

    const cancelTicket: ITicketSlim = {
      ...ticket,
      IsCancelled: !ticket.IsCancelled
    }

    this.wagerFacade.cancelBetAPI(cancelTicket);
    this.isCancelBetSuccessSubs = this.wagerFacade.isCancelBetSuccess$()
    .pipe(
      takeUntil(this.toUnsubscribe$)
    )
    .subscribe((callback) => {

      if (callback?.isSuccess) {
        this.isProcessing = false;
        this.showAlertInfo('Info', 'Tickets cancelled successfully', 'Close', 0);
        this.isCancelBetSuccessSubs?.unsubscribe(); // stop listener/observer if condition meet
      }
      else {
        if (callback?.response && callback?.response !== undefined) {
          this.isProcessing = false;
          this.showAlertInfo(
            'Error',
            callback?.response?.error?.Message || 'Something went wrong',
            'Close',
            0
          );
          this.isCancelBetSuccessSubs?.unsubscribe(); // stop listener/observer if condition meet
        }
      }

    });
  }

  async confirmCancelBet(ticket: ITicketSlim): Promise<void> {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('BetSlipModalComponent:confirmCancelBet', false);
      return;
    }

    if (ticket.IsCancelled) return;

    const alert = await this.alertCtrl.create({
      header: 'Confirm',
      message: 'Submit or Close?',
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Submit',
          handler: () => {
            this.ngZone.run(()=>{

              this.cancelBet(ticket);

            });
          }
        }
      ]
    });

    await alert.present();
  }

  async confirmBet(betType: string, ticket: ITicketSlim): Promise<void> {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('BetSlipModalComponent:confirmBet', false);
      return;
    }

    // if (this.geoLocation === undefined) {
    //   const result = await this.geoLocationService.askPermissionGeoLocation();

    //   if ('latitude' in result && 'longitude' in result) {
    //     if (result === undefined)
    //       return;

    //     if (result.latitude && result.longitude) {
    //       this.wagerFacade.setGeoLocation({
    //         CLat: result.latitude, CLon: result.longitude
    //       });
    //     }

    //     return;
    //   }
    //   else
    //     if (result.showDeviceSetting)
    //       this.showAlertError(result.msg, 'Yes');
    //     else
    //       this.showAlertError(result.msg, '');
    //     return;
    // }

    if (this.geoLocation === undefined) {
      const result = await this.geoLocationService.askPermissionGeoLocation();

      if ('latitude' in result && 'longitude' in result) {
        if (result === undefined) return;

        if (
          (result?.latitude === 0) || (result?.longitude === 0)
          || ((result?.latitude as any) === '0') || ((result?.longitude as any) === '0')
          || (result?.latitude === 0.0) || (result?.longitude === 0.0)
          || ((result?.latitude as any) === '0.0') || ((result?.longitude as any) === '0.0')
          || !result?.latitude || !result?.longitude
        ) return;

        if (result.latitude && result.longitude) {
          this.wagerFacade.setGeoLocation({
            CLat: result.latitude, CLon: result.longitude
          },
          'BetSlipModalComponent:confirmBet');

          ticket = {
            ...ticket,
            Location: {
              ...ticket?.Location,
              CLat: result.latitude,
              CLon: result.longitude
            }
          };
        }
      }
      else {
        if (result.showDeviceSetting)
          this.showAlertError(result.msg, 'Yes');
        else
          this.showAlertError(result.msg, '');
        return;
      }

    }
    else {
      const latitude = this.geoLocation.CLat || undefined;
      const longitude = this.geoLocation.CLon || undefined;

      if (
        (latitude === 0) || (longitude === 0)
        || ((latitude as any) === '0') || ((longitude as any) === '0')
        || (latitude === 0.0) || (longitude === 0.0)
        || ((latitude as any) === '0.0') || ((longitude as any) === '0.0')
        || !latitude || !longitude
      ) return;


      if (latitude && longitude) {
        ticket = {
          ...ticket,
          Location: {
            ...ticket?.Location,
            CLat: latitude,
            CLon: longitude
          }
        };
      }
    }

    if (ticket.TicketAmount > this.balanceAmount && betType === 'submit-saved-bet') {
      this.showAlertInfo('Info', 'Insufficient Funds.', 'Deposit Now', 1);
      return;
    }

    const alert = await this.alertCtrl.create({
      header: 'Confirm',
      message: 'Submit or Close.',
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Submit',
          handler: () => {
            this.ngZone.run(()=>{

              if (betType === 'submit-saved-bet')
                this.submitSavedBet(ticket);
              else
                this.removeSavedBet(ticket);

            });
          }
        }
      ]
    });

    await alert.present();
  }

  getEventName(eventId: string): string {
    const item = _.find(this.events$, (item) =>
      _.get(item, 'ToteResponse.EventDetail.EventId') === eventId);
    return _.get(item, 'ToteResponse.EventDetail.EventName', 'Not found');
  }

  // getTotalAmount() {
  //   this.totalAmount = _.sumBy(
  //     _.filter(this.parentTickets, ['IsCancelled', false]),
  //     'TicketAmount'
  //   );
  // }

  getTotalAmount(ticket: ITicketSlim[], ticketStatus: number): number {
    return _.sumBy(
      _.filter(ticket, (ticket) => !ticket.IsCancelled && ticket.TicketStatus === ticketStatus),
      'TicketAmount'
    );
  }

  convertWordsToAbbre(word: string): string {
    let modifier =  word;

    switch(modifier) {
      case 'Box':
          modifier = 'BX'
        break;
      case 'KeyBox':
          modifier = 'KB'
        break;
      case 'PowerBox':
          modifier = 'PB'
        break;
      case 'KeyWheel':
          modifier = 'KW'
        break;
      default:
          modifier = ''
        break;
    }

    return modifier;
  }

  formatConsecutiveStringFE(runners: string): string {
    const numbersGroups: string[] = runners.split('/');
    const formattedGroups: string[] = [];

    for (const group of numbersGroups) {
      const numbers: string[] = group.split(',');
      let consecutive: string[] = [];
      const formattedGroup: string[] = [];

      for (let i = 0; i < numbers.length; i++) {
        if (parseInt(numbers[i], 10) + 1 === parseInt(numbers[i + 1], 10)) {
          consecutive.push(numbers[i]);
        } else {
          consecutive.push(numbers[i]);

          if (consecutive.length >= 3) {
            formattedGroup.push(`${consecutive[0]}-${consecutive[consecutive.length - 1]}`);
          } else {
            formattedGroup.push(...consecutive);
          }

          consecutive = [];
        }
      }

      formattedGroups.push(formattedGroup.join(','));
    }

    return formattedGroups.join('/');
  }

  savedTab(): void {
    this.showSavedBets = true;
    this.showActiveBets = false;
    this.showClosedBets = false;

    // this.wagerFacade.getBetsAPI({
    //   runId: this.runId,
    //   ticketStatus: 1,
    //   offset: 0,
    //   next: 500
    // }, 'BetSlipModalComponent: savedBet');

    // this.getTotalAmount(this.savedTickets);
  }

  activeTab(): void {
    this.showSavedBets = false;
    this.showActiveBets = true;
    this.showClosedBets = false;

    // this.wagerFacade.getBetsAPI({
    //   runId: this.runId,
    //   offset: 0,
    //   next: 500
    // }, 'BetSlipModalComponent: activeBet');

    // this.getTotalAmount(this.activeTickets);
  }

  closedTab(): void {
    this.showSavedBets = false;
    this.showActiveBets = false;
    this.showClosedBets = true;

    // this.wagerFacade.getBetsAPI({
    //   runId: this.runId,
    //   offset: 0,
    //   next: 500
    // }, 'BetSlipModalComponent: closedBet');

  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  close() {
    // return this.modalCtrl.dismiss(this.name, 'confirm');
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  async showAlertInfo(title: string, msg: string, btn: string, status: number): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: title,
      message: msg,
      buttons: [
        {
          text: btn,
          handler: () => {
            this.ngZone.run(()=>{
              if (status) {
                this.modalCtrl.dismiss();
                this.openFunding();
              }
            });
          }
        }
      ]
    });

    await alert.present();
  }

  async showAlertError(error: string, btn: string): Promise<void> {

    const platform = Capacitor.getPlatform();

    const alert = await this.alertCtrl.create({
      header: 'Error',
      message: error,
      buttons: [
        {
          text: 'Close',
          handler: () => {
          }
        },
        {
          text: btn,
          handler: () => {
            if (btn) {
              this.ngZone.run(()=>{
                if (platform === 'android') {
                  NativeSettings.openAndroid({
                    option: AndroidSettings.Location,
                  });
                }
                this.modalCtrl.dismiss();
              });
            }
          }
        }
      ]
    });

    await alert.present();
  }

  async openFunding(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: FundingComponent,
    });
    modal.present();
  }

}
